export default __webpack_public_path__ + "static/favicon-0a08e6da59121c44844f0910d0dfce91.ico";